import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { IListType } from "../store";
import completedQuestionnaireDataAccess from "src/dataAccess/questionaries/completedQuestionnaireDataAccess";

export const getCompletedQuestionaryListSuccess = createAction<any>(
  "[CompletedQuestionary] Get Completed Questionary List Success"
);
export const loadingList = createAction<boolean>(
  "[CompletedQuestionary] Loading list"
);

export const getCompletedQuestionaryListAsync = createAsyncThunk<
  any,
  IListType
>("[Questionary] Get Questionary List", async (parameter, thunkAPI) => {
  thunkAPI.dispatch(loadingList(true));

  const result = await completedQuestionnaireDataAccess
    .getList(parameter)
    .then((res) => {
      thunkAPI.dispatch(getCompletedQuestionaryListSuccess(res));
      thunkAPI.dispatch(loadingList(false));
      return res;
    });
  return result;
});
